<div class="flex h-full min-h-0 flex-col flex-1 overflow-hidden">
    @if (brands().length === 0) {
    <p class="py-10 text-center text-sm text-secondary m-0">No brands on this agency.</p>
    } @else {
    <div class="min-h-0 flex-1 overflow-y-auto scrollbar-transparent">
        <ul class="flex flex-col gap-1" role="list">
            @for (brand of brands(); track brand.id) {
            <li>
                <button type="button"
                    class="group flex w-full flex-row items-center gap-3 rounded-lg border border-transparent px-3 py-2.5 text-left transition-colors cursor-pointer hover:border-zinc-200 hover:bg-zinc-50 dark:hover:border-zinc-700 dark:hover:bg-zinc-900/80"
                    (click)="onBrandSelect(brand)">
                    <div
                        class="shrink-0 size-10 overflow-hidden rounded-full bg-zinc-100 ring-1 ring-zinc-200/80 dark:bg-zinc-800 dark:ring-zinc-700">
                        @if (brand.companyLogo) {
                        <img [src]="imageService.getImageSource(brand.companyLogo, 'gallery')" alt=""
                            class="size-full object-cover" />
                        } @else {
                        <img src="https://ionicframework.com/docs/img/demos/avatar.svg" alt=""
                            class="size-full object-cover opacity-80" />
                        }
                    </div>
                    <div class="flex min-w-0 flex-1 flex-col gap-0.5">
                        <p class="truncate text-sm font-medium text-primary leading-snug m-0">
                            {{ brand.companyName || 'Unnamed brand' }}
                        </p>
                        <p class="text-xs text-secondary m-0">{{ timeSinceCreated(brand.createdDate) }}</p>
                    </div>
                    @if (brand.isActive === false) {
                    <p
                        class="shrink-0 inline-flex rounded-md bg-zinc-100 px-2 py-0.5 text-xs font-medium text-zinc-600 ring-1 ring-inset ring-zinc-500/20 dark:bg-zinc-800 dark:text-zinc-300 dark:ring-zinc-600/40 m-0">
                        Inactive
                    </p>
                    } @else {
                    <p
                        class="shrink-0 inline-flex rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-800 ring-1 ring-inset ring-emerald-600/20 dark:bg-emerald-900/30 dark:text-emerald-200 dark:ring-emerald-700/40 m-0">
                        Active
                    </p>
                    }
                </button>
            </li>
            }
        </ul>
    </div>
    }
</div>
